namespace TabAurous.Reports {
    export interface UserRolesForm {
        UserId: Serenity.IntegerEditor;
        RoleId: Serenity.IntegerEditor;
    }

    export class UserRolesForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.UserRoles';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UserRolesForm.init)  {
                UserRolesForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(UserRolesForm, [
                    'UserId', w0,
                    'RoleId', w0
                ]);
            }
        }
    }
}
